import { DemoButton } from '@web/components/DemoButton'

const SolutionsFooter = () => {
  return (
    <section className="bg-white py-44 sm:py-32">
      <div className="space-y-4 mx-auto max-w-5xl px-6 lg:px-8">
        <img
          src="/website/pipeline_diagram.svg"
          alt="Pipeline Diagram"
          className="h-auto w-full relative"
          style={{ left: '12px' }}
        />
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-8 px-8 text-brand-navy text-sm relative"
          style={{ left: '-12px' }}
        >
          <div>
            <p className="text-center">
              Multiple data sources, one place. Understand your exposure across your entire district
              or network.
            </p>
          </div>
          <div>
            <p className="text-center">
              See how risk changes over time and under different climate projections. Model how
              consequences cascade.
            </p>
          </div>
          <div>
            <p className="text-center">
              Prioritise investment, test adaptation options, and build business cases that stand up
              to scrutiny.
            </p>
          </div>
        </div>
        <div className="space-y-8 text-center pt-24">
          <h1 className="text-4xl font-light text-brand-blue">
            Ready to understand your risks and build resilience?
          </h1>
          <DemoButton />
        </div>
      </div>
    </section>
  )
}

export default SolutionsFooter
